'use client';

import { sourceSubscribeCTA } from 'constants/constants';

export function calculateBrowserWidth(): number {
  return window.innerWidth && document.documentElement.clientWidth
    ? Math.min(window.innerWidth, document.documentElement.clientWidth)
    : window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
}
